import(/* webpackMode: "eager" */ "/home/runner/_work/frontend-bvnk-hosted-payments-page/frontend-bvnk-hosted-payments-page/src/app/[locale]/(bvnk)/error.tsx");
